<template>
  <div class="relative group" v-click-outside="onClickOutside">
    <component
      :is="tag"
      v-bind="linkProps"
      :class="[
        'flex items-center gap-2 py-2 sm:p-4 sm:hover:bg-gray-50 sm:hover:text-jva-blue-500',
        { 'text-jva-blue-500 sm:bg-gray-50 font-medium': item.isActive },
      ]"
      :aria-haspopup="item.subitems ? 'true' : undefined"
      :aria-expanded="item.subitems && isOpen ? 'true' : 'false'"
      @keydown.space.prevent="toggleSubitems"
      @keydown.enter.prevent="toggleSubitems"
      @click.native="toggleSubitems"
    >
      <span class="">
        {{ item.name }}
      </span>
      <RiArrowDownSLine
        v-if="item.subitems"
        :class="['transition-transform w-4 h-4 fill-current', { 'transform rotate-180': isOpen }]"
      />
    </component>
    <div
      v-if="item.subitems"
      v-show="isOpen"
      class="transition-opacity"
      :class="[
        'opacity-0 pointer-events-none',
        { 'opacity-100 pointer-events-auto': isOpen },
        { 'absolute mt-0 left-0 w-48 shadow-lg bg-white': subitemsMode === 'dropdown' },
        { static: subitemsMode === 'accordion' },
      ]"
    >
      <div class="subitem flex flex-col">
        <DsfrNavSubItem
          v-for="(subitem, index) in item.subitems"
          :key="index"
          :item="subitem"
          :class="[{ 'pl-8': subitemsMode === 'accordion' }]"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { NuxtLink } from '#components'
import { computed, ref } from 'vue'

const props = defineProps({
  item: Object,
  subitemsMode: {
    type: String,
    default: 'dropdown',
    validator: (value) => ['dropdown', 'accordion'].includes(value),
  },
})

const tag = computed(() => {
  if (props.item.as === 'button') return 'button'
  if (props.item.as === 'a') return 'a'
  return NuxtLink
})

const linkProps = computed(() => {
  return {
    ...(props.item.to ? { to: props.item.to, target: props.item.target } : {}),
    ...(props.item.href ? { href: props.item.href, target: props.item.target } : {}),
  }
})

const isOpen = ref(false)

const toggleSubitems = () => {
  if (props.item.subitems) {
    isOpen.value = !isOpen.value
  }
}

const onClickOutside = () => {
  if (isOpen.value) {
    isOpen.value = false
  }
}
</script>

<style scoped>
/* .subitem > :not(:last-child) :deep(.navitem) {
  border-bottom: 1px solid #dddddd;
} */
</style>
